import { Tooltip } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { DocumentPreview } from 'api/notifications';
import { RocketDocument20 } from 'components/atoms/icons';
import { SquadAvatarList } from 'components/atoms/squad-avatar-list';
import { useTranslation } from 'hooks/use-translation';
import { Header } from './components';
import styles from './group.module.css';

interface Props {
  document: DocumentPreview;
}

const Icon = styled(RocketDocument20)`
  margin-right: var(--spacing-04);
  color: var(--blue-60);
`;

export const DocumentHeader: FC<Props> = ({
  document: {
    name,
    project: { name: projectName },
    space: { name: spaceName },
    collaborators,
  },
  children,
}) => {
  const collaboratorsTitle = useTranslation('general.collaborators');
  const titleFallback = useTranslation('fallbacks.document');
  const renderCollaborators = (collaborators ?? []).length > 0;
  const title = name ?? titleFallback;

  return (
    <Header className={styles.header}>
      <Header.Primary>
        <Icon />
        <Header.PrimaryBlock>
          <div title={title} className={`${styles.title} ${styles.ellipsis}`}>
            {title}
          </div>
          <div
            className={`${styles.subtitle} ${styles.ellipsis}`}
          >{`${projectName} ${spaceName != null ? `/ ${spaceName}` : ''}`}</div>
        </Header.PrimaryBlock>
      </Header.Primary>
      <Header.Secondary>
        {renderCollaborators && (
          <Tooltip title={collaboratorsTitle}>
            <SquadAvatarList squad={{ users: collaborators, teams: [] }} />
          </Tooltip>
        )}
      </Header.Secondary>
      <Header.Hanger>{children}</Header.Hanger>
    </Header>
  );
};
